module.exports = __webpack_public_path__ + "static/img/装饰3.40b68ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰3.svg
// module id = y2bq
// module chunks = 2